module.exports = __webpack_public_path__ + "static/media/image_27.5c1c5311.png";